import { Outlet, createFileRoute } from '@tanstack/react-router'

// Layout cha cho nhóm route nhật ký chăm sóc: /care-logs (danh sách),
// /care-logs/new, /care-logs/$id/edit. Chỉ render Outlet để route con hiển thị.
export const Route = createFileRoute(
    '/_app/_authed/_sidebar/agriculture/care-logs',
)({
    component: () => <Outlet />,
})
